import Vue from "vue";

export const ServiceFormEventBus = new Vue();
